import React, { Component } from "react";
import "@babel/polyfill";
import "./SchoolBand.css";
import School from "./School/School";
import leftLines from "../../assets/header/logo/left-lines.png";
import rightLines from "../../assets/header/logo/right-lines.png";
import { Grid, Row, Col } from "react-bootstrap";
import { prefix } from "../../scripts/helpers/constants";

let mainCities = null;
let citiesArray = null;

class schoolBand extends Component {
  state = {
    city: "All Cities",
    gender: "All Genders",
    cities: null,
    genders: ["All Genders", "Boys", "Girls", "Coed"],
  };

  cityClicked = (e) => {
    this.setState({city: e.target.value});
  };

  genderClicked = (e) => {
    this.setState({ gender: e.target.value });
  };

  componentWillMount() {
    mainCities = ["All Cities"];

    citiesArray = mainCities.concat(
      this.props.data.map((key) => {
        return key.city;
      })
    );

    citiesArray = [...new Set(citiesArray)];
    citiesArray = citiesArray.sort();

    let cityFilter = citiesArray.slice();

    this.setState({ cityFilter });
    this.setState({ cities: citiesArray });
  }

  render() {
    return (
      <section className={prefix + "-c-school-band"}>
        <Grid fluid={true} className="no-padding school-band-main">
          <Row className="no-margin">
            <Col xs={12} className="school-sub-band no-padding">
              <Row className="no-margin">
                <Col xs={12} className="no-padding">
                  <div className="school-band-title">
                    <img
                      src={leftLines}
                      alt="Left line"
                      className="school-band-image"
                    />
                    <h2 className="school-band-find">Find a School</h2>
                    <img
                      src={rightLines}
                      alt="Right Line"
                      className="school-band-image"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="no-margin">
                <Col xs={12} className="no-padding">
                  <div className="school-band-filter">
                    <div className="filter-text">
                      <h3>Filter</h3>
                    </div>

                    <label className="custom-select" htmlFor="cities-select">
                      <select
                        id="cities-select"
                        onChange={this.cityClicked}
                        name="options"
                      >
                        {this.state.cityFilter.map((citykey, index) => {
                          return (
                            <option key={index} value={citykey}>
                              {citykey}
                            </option>
                          );
                        })}
                      </select>
                    </label>

                    <label
                      className="custom-select select2"
                      htmlFor="gender-select"
                    >
                      <select
                        id="gender-select"
                        onChange={this.genderClicked}
                        name="options"
                      >
                        {this.state.genders.map((genderKey, index) => {
                          return (
                            <option key={index} value={genderKey}>
                              {genderKey}
                            </option>
                          );
                        })}
                      </select>
                    </label>
                  </div>
                </Col>
              </Row>
              <Row className="no-margin">
                <Col xs={12} className="no-padding">
                  <div className="more-info">
                    <p>
                      For more information about Catholic schools, visit{" "}
                      <a
                        href="https://www.csoboston.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        csoboston.org.
                      </a>
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="no-margin">
                <Col xs={12} className="no-padding">
                  {this.props.data.map((schoolkey) => {
                    return this.state.city === "All Cities" &&
                      this.state.gender === "All Genders" ? (
                      <School
                        description1={schoolkey.description1}
                        description2={schoolkey.description2}
                        gender={schoolkey.gender}
                        city={schoolkey.city}
                        name={schoolkey.school}
                        attributes={schoolkey.attributes}
                        address1={schoolkey.address1}
                        address2={schoolkey.address2}
                        phone={schoolkey.phone}
                        phoneLink={schoolkey.phoneLink}
                        image={schoolkey.image}
                        site={schoolkey.website}
                        admissionLink={schoolkey.admissionLink}
                        maps={schoolkey.maps}
                        secondPhone={schoolkey.secondPhone}
                        secondPhoneLink={schoolkey.secondPhoneLink}
                        key={schoolkey.school+schoolkey.address1}
                        video={schoolkey.videoUrl}
                      />
                    ) : (this.state.city === schoolkey.city ||
                        this.state.city === schoolkey.city2) &&
                      this.state.gender === "All Genders" ? (
                      <School
                        description1={schoolkey.description1}
                        description2={schoolkey.description2}
                        gender={schoolkey.gender}
                        city={schoolkey.city}
                        name={schoolkey.school}
                        attributes={schoolkey.attributes}
                        address1={schoolkey.address1}
                        address2={schoolkey.address2}
                        phone={schoolkey.phone}
                        phoneLink={schoolkey.phoneLink}
                        image={schoolkey.image}
                        site={schoolkey.website}
                        admissionLink={schoolkey.admissionLink}
                        maps={schoolkey.maps}
                        secondPhone={schoolkey.secondPhone}
                        secondPhoneLink={schoolkey.secondPhoneLink}
                        key={schoolkey.school+schoolkey.address1}
                        video={schoolkey.videoUrl}
                      />
                    ) : this.state.city === "All Cities" &&
                      this.state.gender === schoolkey.gender ? (
                      <School
                        description1={schoolkey.description1}
                        description2={schoolkey.description2}
                        gender={schoolkey.gender}
                        city={schoolkey.city}
                        name={schoolkey.school}
                        attributes={schoolkey.attributes}
                        address1={schoolkey.address1}
                        address2={schoolkey.address2}
                        phone={schoolkey.phone}
                        phoneLink={schoolkey.phoneLink}
                        image={schoolkey.image}
                        site={schoolkey.website}
                        admissionLink={schoolkey.admissionLink}
                        maps={schoolkey.maps}
                        secondPhone={schoolkey.secondPhone}
                        secondPhoneLink={schoolkey.secondPhoneLink}
                        key={schoolkey.school+schoolkey.address1}
                        video={schoolkey.videoUrl}
                      />
                    ) : (this.state.city === schoolkey.city ||
                        this.state.city === schoolkey.city2) &&
                      this.state.gender === schoolkey.gender ? (
                      <School
                        description1={schoolkey.description1}
                        description2={schoolkey.description2}
                        gender={schoolkey.gender}
                        city={schoolkey.city}
                        name={schoolkey.school}
                        attributes={schoolkey.attributes}
                        address1={schoolkey.address1}
                        address2={schoolkey.address2}
                        phone={schoolkey.phone}
                        phoneLink={schoolkey.phoneLink}
                        image={schoolkey.image}
                        site={schoolkey.website}
                        admissionLink={schoolkey.admissionLink}
                        maps={schoolkey.maps}
                        secondPhone={schoolkey.secondPhone}
                        secondPhoneLink={schoolkey.secondPhoneLink}
                        key={schoolkey.school+schoolkey.address1}
                        video={schoolkey.videoUrl}
                      />
                    ) : null;
                  })}
                </Col>
              </Row>
              <Row className="no-margin">
                <Col xs={12} className="no-padding">
                  <div id="more-info" className="more-info">
                    <p className="info">
                      For more information about Catholic schools, visit{" "}
                      <a
                        href="https://www.csoboston.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        csoboston.org.
                      </a>
                      {/* <br></br>
                      <br></br>
                      Jaime Gaudet<br></br>
                      Director of School Improvement Planning<br></br>
                      Catholic Schools Office, Archdiocese of Boston<br></br>
                      66 Brooks Drive, Braintree, Massachusetts 02184<br></br>
                      Phone <a href="tel:+1-617-779-3618">
                        (617) 779-3618
                      </a> Fax <a href="tel:+1-617-746-5702">(617) 746-5702</a>
                      <br></br>
                      <a href="mailto:gaudet_j@rcab.org?subject=Request%20for%20information%20about%20Catholic%20elementary%20schools">
                        gaudet_j@rcab.org
                      </a> */}
                    </p>
                    <br></br>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </section>
    );
  }
}

export default schoolBand;



// WEBPACK FOOTER //
// ./src/components/SchoolBand/SchoolBand.js